import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "ui/Dialog";

interface DraftSaveDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
  discardText: string;
  saveText: string;
  isSaving?: boolean;
  onDiscard: () => void;
  onSave: () => void;
  onDismiss: () => void;
}

export default function DraftSaveDialog({
  isOpen,
  title,
  description,
  discardText,
  saveText,
  isSaving = false,
  onDiscard,
  onSave,
  onDismiss,
}: DraftSaveDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onDismiss();
        }
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="mt-4 flex flex-grow flex-col justify-end gap-2 pb-2 sm:flex-row sm:items-center sm:justify-end">
          <button
            type="button"
            className="btn-secondary w-full px-4 py-2 sm:w-fit"
            disabled={isSaving}
            onClick={onDiscard}
          >
            {discardText}
          </button>
          <button
            type="button"
            className={`w-full px-4 py-2 sm:w-fit ${isSaving ? "btn-primary-disabled opacity-60" : "btn-primary"}`}
            disabled={isSaving}
            onClick={onSave}
          >
            {saveText}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
